import { content } from "../../config/content.js";
import { buildAnimatedTitle } from "../HeroTitleAnimation.js";
import { createHeroDashboard } from "../components/HeroDashboard.js";
import { createHeroLogoMarquee } from "../components/HeroLogoMarquee.js";
import { buildSectionPill } from "../components/SectionPill.js";

const checkIcon = `<svg class="hero__tag-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
  <path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export function createHeroSection() {
  const section = document.createElement("section");
  section.id = "hero";
  section.className = "section hero";

  const shell = document.createElement("div");
  shell.className = "section__inner hero__shell";

  const grid = document.createElement("div");
  grid.className = "hero__grid";

  grid.innerHTML = `
    <div class="hero__content">
      <h1 class="hero__title" style="margin-top: 2rem;">${buildAnimatedTitle(content.hero.titleSegments)}</h1>
      <p class="hero__subtitle reveal">${content.hero.subtitle}</p>
      <div class="hero__actions reveal">
        <a class="btn btn--primary" href="${content.hero.ctaPrimaryHref}">${content.hero.ctaPrimary}</a>
        <a class="btn btn--ghost" href="${content.hero.ctaSecondaryHref}">${content.hero.ctaSecondary}</a>
      </div>
      <ul class="hero__tags reveal">
        ${content.hero.tags
          .map((tag) => `<li class="hero__tag">${checkIcon}${tag}</li>`)
          .join("")}
      </ul>
    </div>
  `;

  grid.append(createHeroDashboard());
  shell.append(grid, createHeroLogoMarquee());
  section.append(shell);
  return section;
}
